import React, { useState } from "react";
import { useEffect } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { ValidatorHelper } from "../ValidatorHelper";

interface IProps {
    onChange: (value: string) => void
    validate: boolean;
    validationMessage: string;
    isValid: boolean;
}

export default function PasswordControl(props: IProps) {
    const [inputType, setInputType] = useState<string>("password");
    const [iconName, setIconName] = useState<string>("la-eye");
    
    var element = React.createRef<HTMLInputElement>();

    useEffect(() => {
        setIconName(inputType === "password" ? "la-eye": "la-low-vision")
    }, [inputType])

    const toggleShowCharacters = () => {
        setInputType(inputType === "password" ? "text" : "password");
    }

    useEffect(() => {
        ValidatorHelper.clearCustomValidation(element.current);
        
        if (props.validate && !props.isValid){
            ValidatorHelper.setCustomValidationWithFeedback(element.current, props.validationMessage);
        }
    })

    return (
        <InputGroup>
            <Form.Control ref={element} type={inputType}
                minLength={8}
                required
                onChange={(e) => props.onChange(e.target.value)}
            />
            <InputGroup.Text onClick={toggleShowCharacters}>
                <i className={"las " + iconName} />
            </InputGroup.Text>
            <span className="invalid-feedback pp-font-size-smallest"></span>
        </InputGroup>
    )

}
